


import { HTMLAttributes, ReactElement } from "react";

interface Props extends HTMLAttributes<HTMLElement> {
    color?: string;
}
    
     function Messagequestion({ color }: Props): ReactElement {

    return (
       <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
<g opacity="0.7">
<path d="M14.166 15.3587H10.8327L7.12435 17.8254C6.9992 17.9088 6.85375 17.9567 6.70352 17.9639C6.55328 17.9712 6.4039 17.9375 6.27131 17.8665C6.13872 17.7955 6.02788 17.6898 5.95063 17.5608C5.87339 17.4317 5.83262 17.2841 5.83268 17.1337V15.3587C3.33268 15.3587 1.66602 13.6921 1.66602 11.1921V6.19206C1.66602 3.69206 3.33268 2.02539 5.83268 2.02539H14.166C16.666 2.02539 18.3327 3.69206 18.3327 6.19206V11.1921C18.3327 13.6921 16.666 15.3587 14.166 15.3587Z" stroke={color ? color : "black"} strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round"/>
<path d="M10.0005 9.4668V9.2918C10.0005 8.72513 10.3505 8.42513 10.7005 8.18346C11.0422 7.95013 11.3839 7.65013 11.3839 7.10013C11.3839 6.33346 10.7672 5.7168 10.0005 5.7168C9.23385 5.7168 8.61719 6.33346 8.61719 7.10013M9.99635 11.4585H10.0047" stroke="black" strokeLinecap="round" strokeLinejoin="round"/>
</g>
</svg>
    );
}

export default Messagequestion;